import { THEMES } from './themes'

export const PROVIDERS = {
  OTTO_SCHMIDT: 'ottoschmidt',
  MICROSOFT: 'microsoft',
  MS: 'mohr-siebeck',
  REGUVIS: 'reguvs',
  REHM: 'rehm',
  LINDE: 'linde',
  STAEMPFLI: 'staempfli',
  ERICH_SCHMIDT: 'erichschmidt',
  NKR: 'nkr',
}

export const PROVIDER_THEME_MAP = {
  [PROVIDERS.OTTO_SCHMIDT]: THEMES.OTTO_SCHMIDT,
  [PROVIDERS.NKR]: THEMES.NKR,
  [PROVIDERS.REHM]: THEMES.REHM,
  [PROVIDERS.MS]: THEMES.MOHR_SIEBECK,
  [PROVIDERS.MICROSOFT]: THEMES.LDA_LIGHT,
  [PROVIDERS.REGUVIS]: THEMES.REGUVIS,
  [PROVIDERS.LINDE]: THEMES.LINDE,
  [PROVIDERS.STAEMPFLI]: THEMES.STAEMPFLI,
  [PROVIDERS.ERICH_SCHMIDT]: THEMES.ERICH_SCHMIDT,
}

export const GENERIC_PROVIDERS = new Set([PROVIDERS.MICROSOFT])

export const THEME_PROVIDER_MAP = Object.entries(PROVIDER_THEME_MAP).reduce(
  (acc, [provider, theme]) => {
    acc[theme] = provider
    return acc
  },
  {},
)
